import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminLogsComponent } from './admin.logs/admin.logs.component';
import { GlobalActivityStreamComponent } from './global.activity.stream/global.activity.stream.component';

const LogsRouting: Routes = [
    // login view
    {

        path: 'logs', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: AdminLogsComponent },
            { path: 'admin-logs', component: AdminLogsComponent },
            { path: 'activity-stream', component: GlobalActivityStreamComponent },
			// handle all other routes
            { path: '**', component: AdminLogsComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(LogsRouting)],
    exports: [RouterModule]
})
export class LogsRoutingModule { }
